import { type FC } from 'react'
import { Dropdown } from 'react-bootstrap'
import { ActionButton } from '../../components/DataTable/ActionButton'
import { CustomDropdownItem } from '../../components/Dropdown/CustomDropdownItem'
import { ScopedBlock } from '../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../components/ScopedBlock/models'
import { type InviteResponse } from '../../store/auth/auth'
import { type User } from '../../models/User'
import { type InviteRow, type MemberRow, type TeamRow } from './teamRows'

export interface TeamRowActionHandlers {
  userDeactivationEnabled: boolean
  onEditUser: (user: User) => void
  onDeactivateUser: (user: User) => void
  onDeleteUser: (user: User) => void
  onResendInvite: (invite: InviteResponse) => void
  onDeleteInvite: (invite: InviteResponse) => void
}

export interface TeamRowActionsProps extends TeamRowActionHandlers {
  row: TeamRow
}

const MemberRowActions: FC<TeamRowActionHandlers & { row: MemberRow }> = ({ row, ...handlers }) => {
  const canDeactivate = handlers.userDeactivationEnabled && row.status !== 'deactivated'
  return (
    <ActionButton>
      <ScopedBlock scope={{ scope: 'user:update', superScope: ['user:admin'] }} missingScopeAction={MissingScopeAction.DISABLE}>
        <Dropdown.Item as={CustomDropdownItem} onClick={() => handlers.onEditUser(row.member)}>
          Edit
        </Dropdown.Item>
      </ScopedBlock>
      {canDeactivate ? (
        <ScopedBlock scope={{ scope: 'user:delete', superScope: ['user:admin'] }} missingScopeAction={MissingScopeAction.DISABLE}>
          <Dropdown.Item as={CustomDropdownItem} onClick={() => handlers.onDeactivateUser(row.member)}>
            Deactivate
          </Dropdown.Item>
        </ScopedBlock>
      ) : null}
      <ScopedBlock scope={{ scope: 'user:delete', superScope: ['user:admin'] }} missingScopeAction={MissingScopeAction.DISABLE}>
        <Dropdown.Item as={CustomDropdownItem} onClick={() => handlers.onDeleteUser(row.member)}>
          <span className='zocks-text-danger'>Delete</span>
        </Dropdown.Item>
      </ScopedBlock>
    </ActionButton>
  )
}

const InviteRowActions: FC<TeamRowActionHandlers & { row: InviteRow }> = ({ row, ...handlers }) => (
  <ActionButton>
    <Dropdown.Item as={CustomDropdownItem} onClick={() => handlers.onResendInvite(row.invite)}>
      Resend
    </Dropdown.Item>
    <Dropdown.Item as={CustomDropdownItem} onClick={() => handlers.onDeleteInvite(row.invite)}>
      <span className='zocks-text-danger'>{row.status === 'expired' ? 'Delete' : 'Revoke'}</span>
    </Dropdown.Item>
  </ActionButton>
)

export const TeamRowActions: FC<TeamRowActionsProps> = ({ row, ...handlers }) => {
  if (row.kind === 'invite') {
    if (row.status === 'requested') {
      return null
    }
    return <InviteRowActions row={row} {...handlers} />
  }
  return <MemberRowActions row={row} {...handlers} />
}
